import React from 'react';
import ConnectedBlockSurface from '../../flow/ConnectedBlockSurface';
import type { CanvasSectionBlock } from '../sectionRegistry';

type WrapperProps = React.HTMLAttributes<HTMLDivElement> & {
  style?: React.CSSProperties;
};

type ConnectedBlockRendererProps = {
  block: CanvasSectionBlock;
  blockWrapperProps: WrapperProps;
  selectableBlockHitProps: Record<string, string>;
  selectionTarget: string;
  logicNodeIdTag: React.ReactNode;
  sectionId?: string;
  isAdmin: boolean;
  isInteractPreview: boolean;
  fontLibrary: Record<string, string>;
  renderSelectionOverlay: (block: CanvasSectionBlock) => React.ReactNode;
  onDebugSnapshot: (blockId: string, snapshot: Record<string, unknown> | null) => void;
};

export function ConnectedBlockRenderer({
  block,
  blockWrapperProps,
  selectableBlockHitProps,
  selectionTarget,
  logicNodeIdTag,
  sectionId,
  isAdmin,
  isInteractPreview,
  fontLibrary,
  renderSelectionOverlay,
  onDebugSnapshot,
}: ConnectedBlockRendererProps) {
  return (
    <div key={block.id} {...blockWrapperProps}>
      {logicNodeIdTag}
      <div
        {...(selectionTarget !== 'content' ? selectableBlockHitProps : {})}
        className="h-full w-full"
      >
        <ConnectedBlockSurface
          block={block}
          sectionId={sectionId}
          isAdmin={isAdmin}
          isInteractPreview={isInteractPreview}
          selectionOverlay={renderSelectionOverlay(block)}
          onDebugSnapshot={onDebugSnapshot}
          fontLibrary={fontLibrary}
        />
      </div>
    </div>
  );
}
